export const SIGNUP_REQUEST = 'SIGNUP_REQUEST';
export const SET_AUTH = 'SET_AUTH';
export const LOGIN_REQUEST = 'LOGIN_REQUEST';
export const LOGOUT_REQUEST = 'LOGOUT_REQUEST';
export const VERIFY_USER_FOR_SIGNUP_REQUEST = 'VERIFY_USER_FOR_SIGNUP_REQUEST';
export const RECOVER_PASSWORD_REQUEST = 'RECOVER_PASSWORD_REQUEST';
export const VERIFY_RESET_PASSWORD_REQUEST = 'VERIFY_RESET_PASSWORD_REQUEST';
